<template>
  <form-item>
    <checkbox
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.web_push_safari
      }"
      :title="$t('CampaignForm_Setup_ChooseBrowsers_Safari')"
      v-model="model.web_push_safari"
      data-qa="safari-browser-checkbox"
    />
    <checkbox
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.web_push_firefox
      }"
      :title="$t('CampaignForm_Setup_ChooseBrowsers_Firefox')"
      v-model="model.web_push_firefox"
      data-qa="firefox-browser-checkbox"
    />
    <checkbox
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.web_push_chrome
      }"
      :title="$t('CampaignForm_Setup_ChooseBrowsers_Chrome')"
      v-model="model.web_push_chrome"
      data-qa="chrome-browser-checkbox"
    />
  </form-item>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import Checkbox from '@/common/components/form/Checkbox'
export default {
  name: 'ChooseBrowsers',
  components: {
    Checkbox,
    FormItem
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
>>> .el-form-item__content {
  display: flex;
}

.checkbox-btn {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #dbdee7;
  padding: 15px !important;
  margin-bottom: 10px;
}

.checkbox-btn:not(:last-of-type) {
  margin-right: 10px;
}

.checkbox-btn-active {
  border: 1px solid #1d87c8;
  background-color: #e6f3fb;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/ChooseBrowsers.vue